import React, { useEffect, useContext } from 'react';
import proptypes from 'prop-types';
const { bool, number, string, shape } = proptypes;
import classNames from 'classnames';
import { destroyYouTubePlayer, initializeYouTubePlayers, youTubePlayers } from '../../helpers/videoPlayerHelpers';
import { VideoPlayerContext } from '../../contexts/VideoPlayerContext';
import styles from '../video-player.module.scss';

export const YouTubePlayer = React.forwardRef((props, ref) => {
  const {
    autoPlay, className, enableB2CRadius, height, playerId, width, videoSrc, videoStill, analyticsData
  } = props;
  const { autoPlayInViewport } = useContext(VideoPlayerContext) || {};
  const videoId = `thd-youtube-iframe-${playerId || videoSrc}`;
  const videoSource = `${videoSrc}?autoplay=${!!(autoPlay || videoStill || autoPlayInViewport)}&rel=0&enablejsapi=1`;
  
  useEffect(() => {
    if (!youTubePlayers[videoId]) {
      initializeYouTubePlayers({ analyticsData, muted: autoPlayInViewport, id: videoId });
    }

    return () => {
      destroyYouTubePlayer({ id: videoId });
    };
  }, []);

  return (
    <div
      className={styles['video-player__container']}
      style={{
        width,
        maxWidth: width
      }}
      data-component="YouTubePlayer"
    >
      <iframe
        id={videoId}
        ref={ref}
        className={classNames(className, { 'sui-rounded-xl': enableB2CRadius })}
        src={videoSource}
        title={videoSrc}
        allowFullScreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        height={height}
        width={width}
      />
    </div>
  );
});

YouTubePlayer.propTypes = {
  analyticsData: shape({}),
  autoPlay: bool,
  className: string,
  enableB2CRadius: bool,
  height: number,
  playerId: string,
  videoSrc: string,
  videoStill: bool,
  width: number,
};

YouTubePlayer.defaultProps = {
  analyticsData: null,
  autoPlay: false,
  className: null,
  enableB2CRadius: false,
  height: null,
  playerId: null,
  videoSrc: null,
  videoStill: false,
  width: null
};